// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { PotentialOperationDetailsFragmentDoc } from '../../../../queries/fragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PlanPackageOptionsV2QueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  versionId: Types.Scalars['ID']['input'];
}>;


export type PlanPackageOptionsV2Query = { __typename?: 'Query', planPackage: { __typename?: 'PlanPackage', id: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string }, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, code: string, name: string, type: { __typename?: 'GlobalOptionType', id: string, name: string }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined, optionPrerequisites: Array<{ __typename?: 'ReadyPlanOption', id: string, code: string }>, optionConflicts: Array<{ __typename?: 'ReadyPlanOption', id: string, code: string }>, optionConflictChildren: Array<{ __typename?: 'ReadyPlanOption', id: string, code: string }>, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, programDatas: Array<{ __typename?: 'ReadyPlanProgramData', id: string, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }>, programData: { __typename?: 'ProgramData', id: string, sellableSqft?: number | null | undefined, netBuildableSqft?: number | null | undefined } }> }> } };

export type SavePlanPackageOptionsV2MutationVariables = Types.Exact<{
  input: Types.SavePlanPackageInput;
}>;


export type SavePlanPackageOptionsV2Mutation = { __typename?: 'Mutation', savePlanPackage: { __typename?: 'SavePlanPackageResult', planPackage: { __typename?: 'PlanPackage', id: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, active: boolean }> } } };

export type PlanPackageOptionsV2_PlanPackageFragment = { __typename?: 'PlanPackage', id: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string }, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, code: string, name: string, type: { __typename?: 'GlobalOptionType', id: string, name: string }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined, optionPrerequisites: Array<{ __typename?: 'ReadyPlanOption', id: string, code: string }>, optionConflicts: Array<{ __typename?: 'ReadyPlanOption', id: string, code: string }>, optionConflictChildren: Array<{ __typename?: 'ReadyPlanOption', id: string, code: string }>, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, programDatas: Array<{ __typename?: 'ReadyPlanProgramData', id: string, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }>, programData: { __typename?: 'ProgramData', id: string, sellableSqft?: number | null | undefined, netBuildableSqft?: number | null | undefined } }> }> };

export type PlanPackageOptionsV2_OptionFragment = { __typename?: 'ReadyPlanOption', id: string, code: string, name: string, type: { __typename?: 'GlobalOptionType', id: string, name: string }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined, optionPrerequisites: Array<{ __typename?: 'ReadyPlanOption', id: string, code: string }>, optionConflicts: Array<{ __typename?: 'ReadyPlanOption', id: string, code: string }>, optionConflictChildren: Array<{ __typename?: 'ReadyPlanOption', id: string, code: string }>, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, programDatas: Array<{ __typename?: 'ReadyPlanProgramData', id: string, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }>, programData: { __typename?: 'ProgramData', id: string, sellableSqft?: number | null | undefined, netBuildableSqft?: number | null | undefined } }> };

export const PlanPackageOptionsV2_OptionFragmentDoc = gql`
    fragment PlanPackageOptionsV2_Option on ReadyPlanOption {
  id
  code
  name
  type {
    id
    name
  }
  location {
    id
    name
  }
  optionPrerequisites {
    id
    code
  }
  optionConflicts {
    id
    code
  }
  optionConflictChildren {
    id
    code
  }
  canDelete {
    ...PotentialOperationDetails
  }
  programDatas {
    id
    readyPlanOptions {
      id
    }
    programData {
      id
      sellableSqft
      netBuildableSqft
    }
  }
}
    ${PotentialOperationDetailsFragmentDoc}`;
export const PlanPackageOptionsV2_PlanPackageFragmentDoc = gql`
    fragment PlanPackageOptionsV2_PlanPackage on PlanPackage {
  id
  version {
    id
  }
  canEdit {
    ...PotentialOperationDetails
  }
  options {
    ...PlanPackageOptionsV2_Option
  }
}
    ${PotentialOperationDetailsFragmentDoc}
${PlanPackageOptionsV2_OptionFragmentDoc}`;
export const PlanPackageOptionsV2Document = gql`
    query PlanPackageOptionsV2($id: ID!, $versionId: ID!) {
  planPackage(id: $id, versionId: $versionId) {
    ...PlanPackageOptionsV2_PlanPackage
  }
}
    ${PlanPackageOptionsV2_PlanPackageFragmentDoc}`;

/**
 * __usePlanPackageOptionsV2Query__
 *
 * To run a query within a React component, call `usePlanPackageOptionsV2Query` and pass it any options that fit your needs.
 * When your component renders, `usePlanPackageOptionsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanPackageOptionsV2Query({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function usePlanPackageOptionsV2Query(baseOptions: ApolloReactHooks.QueryHookOptions<PlanPackageOptionsV2Query, PlanPackageOptionsV2QueryVariables> & ({ variables: PlanPackageOptionsV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlanPackageOptionsV2Query, PlanPackageOptionsV2QueryVariables>(PlanPackageOptionsV2Document, options);
      }
export function usePlanPackageOptionsV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlanPackageOptionsV2Query, PlanPackageOptionsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlanPackageOptionsV2Query, PlanPackageOptionsV2QueryVariables>(PlanPackageOptionsV2Document, options);
        }
// @ts-ignore
export function usePlanPackageOptionsV2SuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageOptionsV2Query, PlanPackageOptionsV2QueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanPackageOptionsV2Query, PlanPackageOptionsV2QueryVariables>;
export function usePlanPackageOptionsV2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageOptionsV2Query, PlanPackageOptionsV2QueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanPackageOptionsV2Query | undefined, PlanPackageOptionsV2QueryVariables>;
export function usePlanPackageOptionsV2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageOptionsV2Query, PlanPackageOptionsV2QueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlanPackageOptionsV2Query, PlanPackageOptionsV2QueryVariables>(PlanPackageOptionsV2Document, options);
        }
export type PlanPackageOptionsV2QueryHookResult = ReturnType<typeof usePlanPackageOptionsV2Query>;
export type PlanPackageOptionsV2LazyQueryHookResult = ReturnType<typeof usePlanPackageOptionsV2LazyQuery>;
export type PlanPackageOptionsV2SuspenseQueryHookResult = ReturnType<typeof usePlanPackageOptionsV2SuspenseQuery>;
export type PlanPackageOptionsV2QueryResult = ApolloReactCommon.QueryResult<PlanPackageOptionsV2Query, PlanPackageOptionsV2QueryVariables>;
export const SavePlanPackageOptionsV2Document = gql`
    mutation SavePlanPackageOptionsV2($input: SavePlanPackageInput!) {
  savePlanPackage(input: $input) {
    planPackage {
      id
      version {
        id
      }
      options {
        id
        active
      }
    }
  }
}
    `;

/**
 * __useSavePlanPackageOptionsV2Mutation__
 *
 * To run a mutation, you first call `useSavePlanPackageOptionsV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePlanPackageOptionsV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePlanPackageOptionsV2Mutation, { data, loading, error }] = useSavePlanPackageOptionsV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSavePlanPackageOptionsV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SavePlanPackageOptionsV2Mutation, SavePlanPackageOptionsV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SavePlanPackageOptionsV2Mutation, SavePlanPackageOptionsV2MutationVariables>(SavePlanPackageOptionsV2Document, options);
      }
export type SavePlanPackageOptionsV2MutationHookResult = ReturnType<typeof useSavePlanPackageOptionsV2Mutation>;
export type SavePlanPackageOptionsV2MutationResult = ApolloReactCommon.MutationResult<SavePlanPackageOptionsV2Mutation>;